var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNissanSupplierReleaseSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Nissan_Supplier_release_system",
    "data-name": "Nissan Supplier release system",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_383",
    "data-name": "Rectangle 383",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Supplier",
    d: "M0,4.6A2.508,2.508,0,0,1,2.4,2H21.6A2.508,2.508,0,0,1,24,4.6V18.488a2.508,2.508,0,0,1-2.4,2.6H2.4a2.508,2.508,0,0,1-2.4-2.6ZM4.8,8.942A3.344,3.344,0,0,1,8,5.471a3.344,3.344,0,0,1,3.2,3.471A3.344,3.344,0,0,1,8,12.413,3.344,3.344,0,0,1,4.8,8.942Zm14.4,0H14.4V7.207h4.8Zm0,5.207H14.4V12.413h4.8Zm-11.2,0a4.66,4.66,0,0,0-4.189,2.808L3.284,18.1a.932.932,0,0,0,.035.844A.788.788,0,0,0,4,19.355h8a.788.788,0,0,0,.681-.411.932.932,0,0,0,.035-.844l-.527-1.143A4.66,4.66,0,0,0,8,14.149Z",
    transform: "translate(1 1)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNissanSupplierReleaseSystem);
export default __webpack_public_path__ + "static/media/NissanSupplierReleaseSystem.cbe800bcfbb330fef41cfe5ec74af8fb.svg";
export { ForwardRef as ReactComponent };